// extracted by mini-css-extract-plugin
export default {"modal":"AddJobSeekerModal-module__modal__rANvJ","content":"AddJobSeekerModal-module__content__ShHU0"};